import Icon from '../components/Icon.vue'

Icon.register({"vr-cardboard":{"width":640,"height":512,"paths":[{"d":"M608 64H32C14.3 64 0 78.3 0 96V416C0 433.7 14.3 448 32 448H192.2C217.4 448 240.3 433.2 250.6 410.3L278.3 348.6C286.2 331.1 302.4 320 320 320S353.8 331.1 361.7 348.6L389.4 410.3C399.8 433.2 422.6 448 447.8 448H608C625.7 448 640 433.7 640 416V96C640 78.3 625.7 64 608 64zM160 304C124.7 304 96 275.4 96 240S124.7 176 160 176 224 204.7 224 240 195.3 304 160 304zM480 304C444.6 304 416 275.4 416 240S444.6 176 480 176 544 204.7 544 240 515.4 304 480 304z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/vr-cardboard.js
// module id = null
// module chunks = 